export const getWorkflowTemplates = (activeOnly = true) => `
  query {
    workflowTemplates(activeOnly: ${activeOnly}) {
      id
      name
      description
      version
      isActive
      isBuiltIn
      inputSchema {
        name
        type
        required
        default
        description
      }
      steps {
        id
        name
        type
        dependsOn
        condition
        params
        timeout
        onFailure
        maxRetries
      }
      createdAt
      updatedAt
    }
  }
`;

export const getWorkflowTemplate = (id, name) => `
  query {
    workflowTemplate(${id ? `id: "${id}"` : `name: "${name}"`}) {
      id
      name
      description
      version
      isActive
      isBuiltIn
      inputSchema {
        name
        type
        required
        default
        description
      }
      steps {
        id
        name
        type
        dependsOn
        condition
        params
        timeout
        onFailure
        maxRetries
      }
    }
  }
`;

export const getWorkflowRun = (id) => `
  query {
    workflowRun(id: "${id}") {
      id
      template {
        id
        name
        description
        steps {
          id
          name
          type
          dependsOn
          condition
        }
      }
      templateVersion
      status
      input
      stepStates {
        stepId
        jobId
        status
        result
        error
        startedAt
        completedAt
        retryCount
      }
      error
      startedAt
      completedAt
      createdAt
      updatedAt
    }
  }
`;

export const getWorkflowRuns = (templateId, status, limit = 20, offset = 0) => `
  query {
    workflowRuns(
      ${templateId ? `templateId: "${templateId}"` : ''}
      ${status ? `status: [${status.map(s => s).join(', ')}]` : ''}
      limit: ${limit}
      offset: ${offset}
    ) {
      id
      template { id name }
      status
      startedAt
      completedAt
      createdAt
    }
  }
`;

export const getWorkflowTemplateYAML = (id, name) => `
  query {
    workflowTemplateYAML(${id ? `id: "${id}"` : `name: "${name}"`}) {
      success
      yaml
      error
    }
  }
`;
